import {
    createApp
} from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'

import Functions from "@/utils/functions.js";

import Load from "./LOAD.js"

import "./assets/css/style.css"

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

const enterpriseLightTheme = {
    dark: false,
    colors: {
        background: '#F3F5F9',
        surface: '#FFFFFF',
        'surface-variant': '#EEF1F7',
        'on-surface-variant': '#44506B',
        primary: '#1F4FD1',
        'primary-darken-1': '#173C9E',
        secondary: '#44506B',
        'secondary-darken-1': '#2E3752',
        success: '#12875A',
        warning: '#C9790A',
        error: '#D3352E',
        info: '#2F6FE0',
        accent: '#6D3FD1',
    },
    variables: {
        'border-color': '#1F2C4B',
        'border-opacity': 0.08,
        'high-emphasis-opacity': 0.92,
        'medium-emphasis-opacity': 0.64,
    },
}

const vuetify = createVuetify({
    components,
    directives,
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        },
    },
    theme: {
        defaultTheme: 'enterpriseLightTheme',
        themes: {
            enterpriseLightTheme,
        },
    },
    defaults: {
        VCard: {
            rounded: 'lg',
        },
        VBtn: {
            rounded: 'lg',
            fontWeight: 600,
        },
        VTextField: {
            variant: 'outlined',
            density: 'comfortable',
            rounded: 'lg',
        },
        VSelect: {
            variant: 'outlined',
            density: 'comfortable',
            rounded: 'lg',
        },
        VAppBar: {
            flat: true,
        },
        VNavigationDrawer: {
            elevation: 0,
        },
    },
})

const app = createApp(App)
    .use(store)
    .use(router)
    .use(vuetify)
    .provide('$load', Load)
    .provide('$functions', Functions)

app.mount('#app');
